import * as React from 'react'
import { cn } from '@core/utils'

const BottomSheetHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('grid gap-1.5 p-4 text-center sm:text-left', className)} {...props} />
)
BottomSheetHeader.displayName = 'BottomSheetHeader'

export default BottomSheetHeader
